import React, { useState, useEffect } from 'react'
import { Paper, Stepper, Step, StepLabel, Typography, CircularProgress, Divider, Button, CssBaseline } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';

import { commerce } from '../../../lib/commerce';
import useStyles from "./styles";
import AddressForm from '../AddressForm';
import PaymentForm from '../PaymentForm';

const steps = ["Shipping address", "Payment details"]


const Checkout = ({ cart, order, onCaptureCheckout, error }) => {
    const classes = useStyles();
    const [activeStep, setActiveStep] = useState(0);
    const [checkoutToken, setCheckoutToken] = useState(null);
    const [shippingData, setshippingData] = useState([]);
    const navigate = useNavigate();
    
    

    useEffect(() => {
        if(cart.id){
            
                const generateToken = async () => {
                    try{
                    const token = await commerce.checkout.generateToken(cart.id, {type: 'cart'})
                        
                    setCheckoutToken(token);
                    
                    
            
                        }catch(error){
                            // navigate('/');                    
                    }}
                
                
                generateToken();
                
                
            }

    }, [cart])

    const test = (data) => {
        setshippingData(data);

        nextStep();
        
    }
    console.log(activeStep)
   const nextStep = () => setActiveStep((prevActiveStep) => prevActiveStep + 1) 
   const backStep = () => setActiveStep((prevActiveStep) => prevActiveStep - 1) 

    
    let Confirmation = () => (order.customer ? (
        <>
            <div>
                <Typography variant="h5">Thank you for your purchase, {order.customer.firstname} {order.customer.lastname}</Typography>
                <Divider className={classes.divider}/>
                <Typography variant="subtitle2">Order ref: {order.customer_reference}</Typography>
                <br/>
                <Button component={Link} to="/" variant='outlined'>Back to home</Button>
            </div>
        </>
    ) : (
        <div className={classes.spinner}>
            <CircularProgress/>

        </div>)
    );
    if(error) {
       Confirmation = () => (
        <>
        <Typography variant='h5'>Error: {error}</Typography>
        <br/>
        <Button component={Link} to="/" variant='outlined'>Back to home</Button>
        </>)
    }
        
    const Form = () => activeStep === 0
    ? <AddressForm checkoutToken={checkoutToken} setshippingData={setshippingData} nextStep={nextStep} test={test} />
    : <PaymentForm shippingData={shippingData} checkoutToken={checkoutToken} backStep={backStep} onCaptureCheckout={onCaptureCheckout} nextStep={nextStep}/>

  return (
    <>
    <CssBaseline />
        <div className={classes.toolbar}/>
        <main className={classes.layout}>
            <Paper className={classes.paper}>
                <Typography variant='h4' align="center">Checkout</Typography>
                <Stepper activeStep={activeStep} className={classes.stepper}>
                    {steps.map((step) => (
                        <Step key={step}>
                            <StepLabel>{step}</StepLabel>
                        </Step>
                            
                    ))}
                </Stepper>
                {activeStep === steps.length ? <Confirmation/> : checkoutToken && <Form />}
            </Paper>
        </main>
    </>
  )
}

export default Checkout